export const buildInfo = {
  buildVersion: "2.1.4",
  buildDate: "2024-03-06T09:03:12+0000",
  buildNumber: ""
}
